/* eslint-disable max-len */
import React from 'react';

const CloseIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={9}
    height={9}
    viewBox="0 0 9 9"
    {...props}
  >
    <g id="giphy-Master" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Giphy-02-Search" transform="translate(-974.000000, -258.000000)" fill="currentColor">
        <g id="Giphy-window" transform="translate(736.000000, 232.000000)">
          <g id="giphy-Window" transform="translate(238.000000, 26.000000)">
            <g id="giphy-Xicon">
              <rect
                id="giphy-Rectangle"
                transform="translate(4.500000, 4.500000) rotate(45.000000) translate(-4.500000, -4.500000) "
                x="-1"
                y="4"
                width="11"
                height="1"
              />
              <rect
                id="giphy-Rectangle-2"
                transform="translate(4.500000, 4.500000) rotate(45.000000) translate(-4.500000, -4.500000) "
                x="4"
                y="-1"
                width="1"
                height="11"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default CloseIcon;
